import React from "react";
import CollectionBox from "../Components/Home/Collection/CollectionBox";
import Services from "../Components/Home/Services/Services";
import LimitedEdition from "../Components/Home/Limited/LimitedEdition";
import HeroSection from "../Components/Home/Hero/HeroSection";
import Offers from "../Components/Home/Offers";

const Home = () => {
  return (
    <div className="home_page main__wrapper">
      <HeroSection />
      <div className="home_page_content content__page">
        <CollectionBox />
        <Offers />
        <LimitedEdition />
        <Services />
      </div>
    </div>
  );
};

export default Home;
